import React from 'react';
import { Button, Typography } from '@mui/material';
import AuthCard from './AuthCard.tsx';
import { handoffTo, STUDENT_HOME } from '../utils/handoff.ts';
import type { AreaChoice } from '../utils/routeAfterSignIn.ts';

type Props = {
  choice: AreaChoice;
  navigate: (path: string) => void;
};

const AreaChoiceCard: React.FC<Props> = ({ choice, navigate }) => (
  <AuthCard title="Choose where to continue">
    <Typography variant="body2" color="text.secondary" textAlign="center">
      Your account has access to both areas.
    </Typography>

    <Button
      variant="contained"
      size="large"
      onClick={() => {
        if (choice.studentHandoffUrl) {
          handoffTo(choice.studentHandoffUrl, choice.session);
        } else {
          navigate(STUDENT_HOME);
        }
      }}
    >
      Student app
    </Button>

    <Button
      variant="outlined"
      size="large"
      onClick={() => handoffTo(choice.adminUrl, choice.session)}
    >
      Admin app
    </Button>
  </AuthCard>
);

export default AreaChoiceCard;
